import styled, { css } from "styled-components";
import { ButtonProps } from "../../../components/atoms/Buttons";

export const MatchListLayot = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
`;

export const SearchLayout = styled.form`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 6px;
`;

export const FilterButton = styled.div`
  width: 35%;
  display: flex;
  align-items: center;
  gap: 6px;
  background: ${(props) => props.theme.colors.white};
  box-shadow: ${(props) => props.theme.shadow.box};
  color: ${(props) => props.theme.colors.black};
  border-radius: 4px;
  font-size: 1.5rem;
  font-weight: 500;
  white-space: nowrap;
  padding-left: 6px;

  &:active {
    background: ${(props) => props.theme.colors.grayBg};
  }

  &.isOpen {
    border: 1px solid ${(props) => props.theme.colors.primary};
    background: ${(props) => props.theme.colors.checkBoxBg};
    color: ${(props) => props.theme.colors.primary};
  }
`;

export const FilterRouteBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;

export const DetailRouteBox = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
`;

export const DetailRoute = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;

  @media (max-width: 480px) {
    align-self: flex-end;
  }

  div {
    font-size: 1.5rem;
    font-weight: 600;
    color: ${(props) => props.theme.colors.primary};
  }
`;

export const Button = styled.button`
  display: flex;
  color: white;
  box-shadow: ${(props) => props.theme.shadow.box};
  background: ${(props) => props.theme.colors.tagBg};
  border: none;
  border-radius: 5px;
  align-items: center;
  justify-content: center;
  gap: 4px;
  width: auto;
  min-width: 60px;
  height: 40px;
  padding: 0 8px;
  font-size: 1.4rem;
  font-weight: 500;
  &:active {
    background: ${(props) => props.theme.colors.black};
  }
`;

export const MiddleBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const FilterLayout = styled.div`
  width: 68%;
  overflow: scroll;
  display: flex;
  flex-direction: row;
  gap: 6px;
`;

export const FilterDataBox = styled.div`
  width: fit-content;
  height: fit-content;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background: ${(props) => props.theme.colors.black}80;
  border-radius: 4px;
  padding: 5px 9px;
  gap: 12px;

  p {
    white-space: nowrap;
    font-size: 1.4rem;
    font-weight: 600;
    color: ${(props) => props.theme.colors.white};
  }
`;

export const DateFilter = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 3px;

  div {
    font-size: 1.6rem;
    white-space: nowrap;
  }
`;

export const ButtonBox = styled.button<ButtonProps>`
  display: flex;
  color: ${(props) =>
    props.color === "white"
      ? props.theme.colors.primary
      : props.color === "transparent"
      ? props.theme.colors.primary
      : props.theme.colors.white};
  background: ${(props) =>
    props.color === "transparent"
      ? "none"
      : props.color
      ? props.theme.colors[props.color]
      : props.theme.colors.primary};
  border: none;
  border-radius: 6px;
  align-items: center;
  justify-content: center;
  gap: 4px;

  &:active {
    background: ${(props) =>
      props.color === "transparent"
        ? props.theme.colors.whiteActive
        : props.color
        ? props.theme.colors[props.color + "Active"]
        : props.theme.colors.primaryActive};
  }

  ${(props) =>
    props.size === "md" &&
    css`
      width: 100%;
      height: 30px;
      font-size: 1.4rem;
      font-weight: 600;
    `}
`;

export const Input = styled.input`
  background: ${(props) => props.theme.colors.inputBg};
  border: 1px solid white;
  outline: none;
  transition: all 0.3s;
  padding: 0 12px;
  font-size: 1.4rem;
  border-radius: 5px;
  width: 100%;
  height: 40px;
  box-shadow: ${(props) => props.theme.shadow.box};
  &::placeholder {
    font-size: 1.4rem;
    opacity: 0;
    transition: all 0.3s;
    opacity: 1;
    animation-delay: 0.2s;
  }
`;

export const DataCardBoxLayout = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 12px;
`;

export const MainContentsList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const MainContentsSection = styled.section`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const MainContentsItem = styled.li`
  display: flex;
  padding: 20px 15px;
  background: ${(props) => props.theme.colors.white};
  border-radius: 16px;
  box-shadow: ${(props) => props.theme.shadow.box};
  flex-direction: column;
  gap: 20px;
`;

export const NodataItemBox = styled.div`
  display: flex;
  color: ${(props) => props.theme.colors.placeholderTxt};
  align-items: center;
  justify-content: center;
  flex-direction: column;

  p {
    display: flex;
    height: 120px;
    font-size: 1.4rem;
    align-items: center;
    justify-content: center;
  }
`;

export const DataItemBox = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
`;

export const DataHeadBox = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: flex-start;

  & > div {
    display: flex;
    padding-left: 5px;
    font-size: 1.6rem;
    font-weight: 600;
    align-items: center;
    gap: 6px;
  }
`;

export const DataListBox = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  align-items: center;
  justify-content: center;
  gap: 5px;
`;

export const DataRouteBox = styled.div`
  display: grid;
  margin: 18px 0;
  padding: 15px 0;
  background: ${(props) => props.theme.colors.mainBg};
  border-radius: 10px;
  grid-template-columns: 1fr 10px 1fr 10px 1fr;
  align-items: center;
  justify-content: center;

  /* display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  align-items: center;
  background: ${(props) => props.theme.colors.mainBg};
  border-radius: 10px;
  padding: 15px;
  gap: 12px; */
`;

export const ContainerBookingBox = styled.div`
  display: flex;
  flex-direction: row;
  gap: 12px;
  align-items: center;
`;

export const ContainerNo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3px;
  width: 145px;
  flex-shrink: 0;

  span:first-child {
    font-size: 1.2rem;
    color: ${(props) => props.theme.colors.gray};
    font-weight: 500;
  }

  span:last-child {
    padding: 6px 10px;
    border-radius: 8px;
    background: #e8efff;
    color: ${(props) => props.theme.colors.primary};
    font-size: 1.7rem;
    font-weight: 600;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export const BookingNo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3px;
  width: 145px;
  flex-shrink: 0;

  span:first-child {
    font-size: 1.2rem;
    color: ${(props) => props.theme.colors.gray};
    font-weight: 500;
  }

  span:last-child {
    padding: 6px 10px;
    border-radius: 8px;
    background: #e8efff;
    color: ${(props) => props.theme.colors.primary};
    font-size: 1.7rem;
    font-weight: 600;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export const ShippingNumberDivider = styled.div`
  width: 100%;
  height: 1px;
  background: ${(props) => props.theme.colors.inputBorder};
  margin: 15px 0 10px 0;
`;

export const ShippingNumberBox = styled.div`
  display: flex;
  flex-direction: row;
  gap: 5px;

  span:first-child {
    font-size: 1.3rem;
    color: ${(props) => props.theme.colors.black};
    font-weight: 500;
  }

  span:last-child {
    font-size: 1.3rem;
    color: ${(props) => props.theme.colors.gray};
    font-weight: 500;
  }
`;
